import { useEffect, useState } from 'preact/hooks'
import {
  updateCartItem,
  removeCartItem,
  updateCart,
  getCartBadges,
  getCartInfo,
  getCartProperties,
  getDisableChangeQuantity,
  getMaxQuantity,
  removeBundlesItem,
  changeQuantityBundlesProduct,
  checkProductPersonalised,
  getQuantity,
  getQuantityByCarton
} from 'helpers/cart'
import { getProductTitle } from 'uses/useShopify'
import { hasOwnProperites } from 'helpers/utils'
import Image from 'snippets/image/image'
import QuantityInput from 'snippets/quantity-input/quantity-input'
import Price from 'snippets/price/price'
import CartInfo from 'snippets/cart-info/cart-info'
import Badge from 'snippets/badge/badge'
import Icon from 'snippets/icon/icon'

function MiniCartItem({ item, setCart, setFetching }) {
  const [quantity, setQuantity] = useState(getQuantity(item))

  const [isLoading, setIsLoading] = useState(false)

  const badges = getCartBadges(item.tags, item.properties)

  const infos = getCartInfo(item)

  const properties = getCartProperties(item.properties)

  const isChildProduct = getDisableChangeQuantity(properties)

  const isProductPersonalised = checkProductPersonalised(properties)

  const isBundles = item.properties && hasOwnProperites('byopBundles', item.properties)

  const productTitle =
    getProductTitle(
      item.product_has_only_default_variant && item.weight > 0 && !item.tags.includes('hidden'),
      item.product_title,
      item.weight,
      item.weight_unit
    ) + (item.variant_title != null ? ' | ' + item.variant_title : '')

  const maxQuantity = getMaxQuantity(item)

  const onRemove = async () => {
    setFetching(true)
    setIsLoading(true)
    if (!isBundles) {
      await removeCartItem(item.key)
    } else {
      await removeBundlesItem(item)
    }
    const newCart = await updateCart()
    setCart(newCart)
    setFetching(false)
    setIsLoading(false)
  }

  const onChangeQuantity = async (quantity) => {
    setFetching(true)
    setIsLoading(true)
    if (!isBundles) {
      await updateCartItem(item.key, quantity * getQuantityByCarton(item))
    } else {
      await changeQuantityBundlesProduct(item, quantity)
    }
    const newCart = await updateCart()
    setCart(newCart)
    setFetching(false)
    setIsLoading(false)
  }

  useEffect(() => {
    if (item.quantity !== quantity) {
      onChangeQuantity(quantity)
    }
  }, [quantity])

  return (
    <div className="grid gap-4 grid-cols-[64px_1fr_20px] border-t border-default py-4 md:py-6 items-start first:border-t-0">
      <div className="row-span-2">
        <Image imageUrl={[item.featured_image.url]} className="aspect-[1/1]" key={item.id} />
      </div>
      <div className="flex flex-col self-start md:self-center max-w-[172px] md:max-w-[212px]">
        {item.tags && item.tags.includes('hidden')
          ? (<p className="text-sm text-grey-900" title={item.title}>{productTitle}</p>)
          : (<a href={item.url} className="text-sm text-grey-900" title={item.title}>{productTitle}</a>)
        }
        <CartInfo
          infos={infos}
          properties={properties}
          isGiftCard={item.gift_card || item.product_type === 'Gift card'}
          isHidden={item.tags && item.tags.includes('hidden')}
        />
        <Badge items={badges} ignoreList={window.SLS_STATE.customBadge.ignore} className="flex gap-2 pt-2" />
      </div>
      {!isChildProduct && (
        <div className="md:text-right">
          <button type="button" className="link" onClick={onRemove}>
            <Icon className="w-5 h-5 text-grey-700" name="icon-trash" viewBox="0 0 20 20" />
          </button>
        </div>
      )}
      <div className="flex items-center justify-between col-span-2">
        <div>
          <QuantityInput
            key={`${item.id}-${item.quantity}-${isBundles ? quantity : 'normal'}`}
            quantity={item.quantity / getQuantityByCarton(item)}
            min="0"
            max={maxQuantity}
            setQuantity={setQuantity}
            disabled={isChildProduct || isProductPersonalised}
            label="carton"
            isLoading={isLoading}
            className="min-w-[160px]"
          />
        </div>
        {!isProductPersonalised && (
          <div className="order-1 text-right md:order-none">
            <Price price={item.price} originalPrice={item.compare_at_price} discountedPrice={item.line_price} quantity={item.quantity} className="flex flex-col text-primary" classColor="text-grey-900" />
          </div>
        )}
      </div>
    </div>
  )
}

export default MiniCartItem
